export default "__VITE_ASSET__BoHhuW4G__"